var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import StyledSvgWrapper from './utils/StyledSvgWrapper';
const SvgIcon = (props) => {
    const { size, color, className: classNameProp, forwardedRef, IconComp } = props, rest = __rest(props, ["size", "color", "className", "forwardedRef", "IconComp"]);
    const sizeMap = {
        s: '_ndsIcon--small',
        m: '_ndsIcon--medium',
        l: '_ndsIcon--large'
    };
    return (React.createElement(StyledSvgWrapper, Object.assign({ className: clsx(sizeMap[size], classNameProp, IconComp.name), ref: forwardedRef, fill: "none" }, rest),
        React.createElement(IconComp, { color: color })));
};
SvgIcon.propTypes = {
    size: PropTypes.oneOf(['s', 'm', 'l']),
    color: PropTypes.oneOfType([PropTypes.string]),
    className: PropTypes.string,
    forwardedRef: PropTypes.any,
    IconComp: PropTypes.func
};
SvgIcon.defaultProps = {
    size: 'm',
    color: undefined,
    className: undefined,
    forwardedRef: null,
    IconComp: null
};
export { SvgIcon as IconRootComp };
export default SvgIcon;
//# sourceMappingURL=SvgIcon.js.map